import Component from "flarum/common/Component";
import app from 'flarum/forum/app';
export default class GuestWelcomeBox extends Component {
  oninit(vnode) {
    super.oninit(vnode);
  }
  view(vnode) {
    const isSignupEnabled = app.forum.attribute('allowSignUp');
    const emptyAvatarImg = app.forum.attribute('imgUrl') || app.forum.attribute('baseUrl') + '/assets/extensions/justoverclock-welcomebox/no-avatar.png';
    return m("div", {
      className: "containerwb"
    }, m("div", {
      className: "backgrwbguest"
    }, m("img", {
      className: "guestavatarimg",
      src: emptyAvatarImg,
      alt: ""
    }), m("div", {
      className: "guesttext"
    }, app.translator.trans('flarum-ext-welcomebox.forum.welcomeguest')), m("p", {
      className: "guestdesc"
    }, app.translator.trans('flarum-ext-welcomebox.forum.notregistered')), m("div", {
      className: "contentwb"
    }, isSignupEnabled && m("button", {
      className: ".SplitDropdown-button Button Button--primary hasIcon",
      type: "button",
      onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal'))
    }, app.translator.trans('core.forum.header.sign_up_link')))));
  }
}
flarum.reg.add('justoverclock-welcomebox', 'forum/components/GuestWelcomeBox', GuestWelcomeBox);